import { render } from "./RoundedButton.vue?vue&type=template&id=65c8b134"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
